export enum ProductFrequencyEnum {
    ONE_TIME_PAYMENT = 1,
    PER_MONTH = 2,
}
